import React from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import API from './api';
import {history} from '../routers/AppRouter';
import ScrollArea from 'react-scrollbar';
import PageAnimation from '../components/PageTransitions';


class AboutPage extends React.Component{

  state = {
    page_title : '',
    subtitle : '',
    page_content: ''
  }
  componentWillMount = () =>{
    if (this.props.aboutData.dataIn){
      // if data stored on Redux
      this.setState({
        page_title:this.props.aboutData.page_title,
        subtitle:this.props.aboutData.subtitle,
        page_content:this.props.aboutData.page_content
      });
    } else{
      // if data not stored on Redux try to fetch again
      API.get(`about`)
      .then(res => {
        const aboutData = res.data;
        this.setState({
          page_title:aboutData.page_title,
          subtitle:aboutData.subtitle,
          page_content:aboutData.page_content
        });
      });
    }
    
  }
  
  render(){
      return(
        <PageAnimation frompage={history.location.state.prevPath} topage={history.location.pathname} animP="/about">
        <ScrollArea
            smoothScrolling={true}
            onScroll={() => {
              document.querySelector(".logo").classList.remove("home");
            }}
            className="aboutPage"
            verticalContainerStyle={{background:"#eb9c29"}}
            verticalScrollbarStyle={{background:"#ffddac"}}
            horizontal={false}
            >
          
          <div className="fixedNav">
            <Link className="back" to={{pathname: 'work', state: { prevPath: location.pathname }}}>Work <span className="icon-back-right"></span></Link>
            <p className="current"><span className="icon-arrow-left"></span> About</p>
          </div>
          <div className="topShadow"></div>
          <div className="bContainer">
            <div className="title">
              <p>{this.state.subtitle}</p>
              <h1>{this.state.page_title}</h1>
            </div>
            <div className="content">
              <div className="row">
                <div className="col-sm-8 col-xs-12">
                  <div dangerouslySetInnerHTML={{__html: this.state.page_content}}/>
                </div>
                <div className="col-sm-4 col-xs-12">
                  <div className="designRushLogo">
                    <a href="https://www.designrush.com/agency/profile/bni" target="_blank">
                      <img  src="./images/DesignRush-Badge-2023.png"></img>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollArea>
        </PageAnimation>
      );
  }
}




const mapStateToProps = (state) =>{
  return{
      aboutData: state.about
  };
};


export default connect(mapStateToProps)(AboutPage);



// WEBPACK FOOTER //
// ./src/components/AboutPage.js